import { ColumnDef } from "@tanstack/table-core/build/lib/types";
import { EquipmentVehicle, EquipmentVehicleSortField } from "../../graphql/graphql";
import { formatDate, mapHealthStatusToIndicator } from "../../shared/Utils";
import { modeOfTransportOptions } from "../../shared/ColumnOptions";
import { StatusIndicator } from "@nike/eds";


export type VehicleTableColumn<T> = ColumnDef<T, any> & {
  header: string | React.ReactNode | (() => React.ReactNode);
  accessorKey: keyof T | string;
  filterLabel?: string;
  filterType?: "select" | "text" | "date" | "dateRange";
  filterOptions?: Array<{ value: string; label: string }>;
  getFilterOptions?: (tableState: any) => Array<{ value: string; label: string }>;
  enableHiding?: boolean;
  enableSorting?: boolean;
  sortableField?: EquipmentVehicleSortField;
  filterKey?: string;
};

export const getVehicleTableColumns = (): VehicleTableColumn<EquipmentVehicle>[] => [
  {
    header: () => (<span title="Health Status">Health</span>),
    accessorKey: "health",
    cell: ({ row }) => <StatusIndicator size='x-large' label={row.original.health?.health} status={mapHealthStatusToIndicator(row.original.health?.health)} />,
    size: 120,
    enableColumnFilter: false,
    enableSorting: false
  },
  {
    header: () => (<span title="ETA / Planned Discharge Date">ETA</span>),
    accessorKey: "plannedDischargeDate",
    cell: ({ row }) => formatDate(row.original.plannedDischargeDate),
    size: 120,
    enableSorting: true,
    sortableField: EquipmentVehicleSortField.PlannedDischargeDate,
    enableColumnFilter: true,
    filterType: "dateRange",
    filterLabel: "ETA",
    filterKey: "plannedDischargeDate",
  },
  {
    header: () => (<span title="Mode of Transport">MOT</span>),
    accessorKey: "modeOfTransport",
    size: 120,
    enableSorting: false,
    filterLabel: "Mode of Transport",
    filterType: "select",
    filterOptions: modeOfTransportOptions,
  },
  {
    header: () => (<span title="Voyage Number">VN</span>),
    accessorKey: "voyageNumber",
    size: 150,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    header: () => (<span title="Carrier">Carrier</span>),
    accessorKey: "carrier",
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    header: () => (<span title="# of Consignments"># of Consignments</span>),
    accessorKey: "consignmentCount",
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    header: () => (<span title="Open Exceptions">Open Exceptions</span>),
    accessorKey: "openExceptionCount",
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    header: () => (<span title="Shipment Count (Actual/Expected)">Shipment Count</span>),
    accessorKey: "expectedShipmentCount",
    size: 120,
    cell: ({ row }) => (<span style={{ color: row.original.actualShipmentCount ? 'inherit' : 'red' }}>{row.original.actualShipmentCount?row.original.actualShipmentCount:'--'} / {row.original.expectedShipmentCount?row.original.expectedShipmentCount:'--'}</span>),
    enableColumnFilter: false,
    enableSorting: false
  },
  {
    header: () => (<span title="Export Country">Export Country</span>),
    accessorKey: "originCountry",
    size: 120,
    enableSorting: false,
    filterLabel: "Export Country",
    filterType: "select",
    getFilterOptions: (table) => table.options.meta?.originCountryOptions || [],
  },
  {
    header: () => (<span title="Discharge Country">Discharge Country</span>),
    accessorKey: "dischargeCountry",
    size: 120,
    enableSorting: false,
    filterLabel: "Discharge Country",
    filterType: "select",
    getFilterOptions: (table) => table.options.meta?.dischargeCountryOptions || [],
  },
];

